import { Icon, Icons } from "@phoenix/components/icon";

export const FieldSuccessIcon = () => {
  return (
    <Icon color="success" className="ac-field-icon" svg={<Icons.Checkmark />} />
  );
};
